import { AdminBarberRepository } from "../../Repository";

export async function deleteBarberEmployee(
  employeeName: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.deleteBarberEmployee(employeeName);
}
